import { getSingleJobListing } from "app/api/job_api";
import { useQuery } from "@tanstack/react-query";

/**
 * React Query hook to fetch a single job listing by ID.
 *
 * @param {string|number} selectedRowId - The job post ID to fetch.
 * @param {boolean} isUpdating - If true, refetches when updating (used in query key for cache busting).
 * @param {number} [staleTime=0] - Optional. Time in ms for which data is considered fresh.
 * @param {boolean} [shouldFetchCompanyLogo=false] - Optional. If true, fetches company logo with job data.
 * @returns {import("@tanstack/react-query").UseQueryResult<any>} React Query result object with job data, loading, and error states.
 */
const useGetJob = (selectedRowId, isUpdating, staleTime = 0, shouldFetchCompanyLogo = false) => {
  return useQuery({
    queryKey: ["get_single_job", selectedRowId, isUpdating, shouldFetchCompanyLogo],
    queryFn: () => getSingleJobListing(selectedRowId, shouldFetchCompanyLogo),
    enabled: !!selectedRowId,
    staleTime: staleTime
  });
};

export default useGetJob;
